import { render, staticRenderFns } from "./ErrorAttendance.vue?vue&type=template&id=2df33725&scoped=true"
import script from "./ErrorAttendance.vue?vue&type=script&lang=js"
export * from "./ErrorAttendance.vue?vue&type=script&lang=js"
import style0 from "./ErrorAttendance.vue?vue&type=style&index=0&id=2df33725&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2df33725",
  null
  
)

export default component.exports